// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__F62W5","user_name":"styles_user_name__WSSCj","stars":"styles_stars__8uBMG","text":"styles_text__ppEOy"};